<template>
  <div class="page page-wide" id="page-campaigns">
    <Metadata
      :title="this.title"
    />
    <NavLeft
      v-bind:advertiserLabel="this.advertiser.label"
      v-bind:advertiserReportingLabel="this.advertiser.reportingLabel"
      v-bind:campaigns="this.campaigns"
    />
    <div class="content-wrapper">
      <div class="content" id="content-campaigns">
        <div class="page-heading">
          <div class="breadcrumbs_container">
            <span class="breadcrumbs-initial" v-if="this.advertiser.reportingLabel && this.advertiser.reportingLabel !== ''">
              {{this.advertiser.reportingLabel}}
            </span>
            <span class="breadcrumbs-initial" v-else>
              {{this.advertiser.label}}
            </span>
          </div>
          <h1 class="heading-h1">Campaigns:</h1>
        </div>
        <ul class="campaigns-list">
          <template v-for="campaign in campaigns.slice().reverse()">
            <li class="campaigns-list_item">
              <router-link
                class="campaign-list_link"
                :to="{ name: 'campaignByLabel', params: { campaignLabel: campaign.label }}">
                <span v-if="campaign.reportingLabel && campaign.reportingLabel !== ''">
                  {{campaign.reportingLabel}}
                </span>
                <span v-else>
                  {{campaign.label}}
                </span>
                <Detail
                  v-bind:label="campaign.label"
                  v-bind:embedUrl="campaign['embed.url']['summary']"
                  type="campaigns"
                />
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

import Top from '../components/nav/Top.vue';
import NavLeft from '../components/nav/LeftCampaigns.vue';
import Bottom from '../components/nav/Bottom.vue';

import Detail from '../components/Detail.vue';

export default {
  name: 'campaigns',
  components: {
    Top,
    NavLeft,
    Bottom,
    Detail,
  },
  created() {
    const { advertiserLabel } = this.$route.params;
    this.advertiser = this.$store.state.advertisers
      .find(advertiser => advertiser.label === advertiserLabel);
    this.campaigns = this.advertiser.campaigns;
  },
  data() {
    return {
      title: `reporting - campaigns`,
      advertiser: null,
      campaigns: null,
    };
  },
};
</script>

<style>

/* campaigns */

#page-campaigns .content-wrapper {
  overflow-y: auto;
  overflow-x: hidden;
}

.campaigns-list {
  margin-top: 40px;
}

.campaigns-list_item {
  display: inline-block;
  width: 94%;
  min-height: 410px;
  cursor: pointer;
  background: #fff;
  box-shadow: 0px 1px 3px rgba(200,200,200,0.5);
  border-radius: 5px;
  font-weight: 400;
  font-size: 20px;
  transition: 0.1s all ease;
  margin: 10px 40px;
}

.campaigns-list_item:after {
  content: '';
  position: absolute;
  bottom: 5px;
  right: 30px;
  height: 24px;
  width: 150px;
  background: #fff;
}

.campaigns-list_item:hover {
  box-shadow: 0px 1px 20px rgba(200,200,200,0.8);
}

.campaign-list_link {
  display: block;
  height: 400px;
  padding: 20px;
}

</style>
